import type { ReactNode } from "react";

/* A status: a word with its color beside it.
 *
 * The word does the work and the color reinforces it, because color is never
 * the only carrier of meaning (docs/design-standards.md, Accessibility). The
 * same meaning gets the same tone on every screen, so the tones are named
 * for what they mean and not for a color.
 *
 * ok        Found, done, current.
 * waiting   Queued, running, expected.
 * refusal   Refused, failed, wrong.
 * quiet     A state that is news to nobody: not searched, no result.
 * plain     A category with no judgment in it. */
export type Tone = "ok" | "waiting" | "refusal" | "quiet" | "plain";

export function Badge({ tone = "plain", title, children }: {
  tone?: Tone;
  title?: string | undefined;
  children: ReactNode;
}) {
  return <span className={`ui-badge ui-badge-${tone}`} title={title}>{children}</span>;
}
